import React, { useState } from "react";
import styles from "./ExposedPerson.module.sass";
import RadioGroup from "../../ui/RadioGroup/RadioGroup";
import Tooltip from "../../ui/Tooltip/Tooltip";

const exposedPerson = (props) => {
  const [exposedPerson, setExposedPerson] = useState("N");

  const getPFMessage = () => {
    return (
      <b>
        {props.cj
          ? "Seu(a) cônjuge é uma pessoa politicamente exposta?"
          : "Você é uma pessoa politicamente exposta?"}
      </b>
    );
  };

  return (
    <div className={styles.ExposedPersonText}>
      <div className={"flex-row"}>
        <p>
          {props.pf ? (
            getPFMessage()
          ) : (
            <b>Você ou algum dos sócios são pessoas politicamente expostas?</b>
          )}
          <Tooltip>
            <p>
              Você é considerada uma Pessoa Politicamente Exposta se está ou
              esteve nos últimos 5 (cinco) anos, em cargos, empregos ou funções
              públicas relevantes, no Brasil ou em outros países. Por exemplo:
              chefes de estado, políticos de alto nível, altos servidores
              governamentais, judiciais, militares, entre outros. E se você for
              representante, familiar ou tenha um relacionamento próximo com
              alguém assim, também é considerado PEP.
            </p>
          </Tooltip>
        </p>
      </div>

      <RadioGroup
        options={["Sim", "Não"].map((el) => ({
          value: el === "Sim" ? "S" : "N",
          text: el,
        }))}
        value={exposedPerson}
        onChanged={(value) => {
          setExposedPerson(value);
          props.onChange(value);
        }}
      />
    </div>
  );
};

export default exposedPerson;
